import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { Dialog, CommandBar, IContextualMenuItem, ICommandBarItemProps } from "office-ui-fabric-react";
import { BaseFieldEditor } from "../helper";
import { getLanguages, getFieldTranslations } from "~/state/action";
import { loadTranslations, addOrUpdateFieldValue } from "~/state/field/action";
import { languageMenu } from "~/util/language";
import { Language, FieldValueDropdown } from "typings";
import KeyValueList from "~/components/translations/KeyValueList";

export interface Props extends BaseFieldEditor
{
    value: FieldValueDropdown;
    onClose: () => void;
}

interface State
{
    language?: Language;
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    languages: getLanguages(state),
    translations: getFieldTranslations(state, ownProps.field.name)
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadTranslations: (fieldName: string, language: string, valuesUrl: string) =>
        dispatch(loadTranslations(fieldName, language, valuesUrl)),
    addOrUpdateFieldValue: (fieldName: string, language: string, valuesUrl: string, key: string, value: string) =>
    dispatch(addOrUpdateFieldValue(fieldName, language, valuesUrl, key, value)),
});

class TranslationDialog extends React.Component<Props & StateProps, State>
{
    state: State = {
        language: undefined
    };

    componentDidMount()
    {
        if (this.props.languages && this.props.languages.length > 0)
        {
            const lang = this.props.languages[0];
            this.setState( { language: lang });
            if (this.props.value && this.props.value.valuesUrl)
            {
                this.props.loadTranslations(this.props.field.name, lang.name, this.props.value.valuesUrl);

            }
        }
    }

    onLanguageClick = async (language: string) =>
    {
        const lang = this.props.languages.find(x => x.name === language);
        if (lang)
        {
            if (this.props.value && this.props.value.valuesUrl)
            {
                await this.props.loadTranslations(this.props.field.name, lang.name, this.props.value.valuesUrl);
            }
            this.setState( { language: lang });
        }
    } 

    onListChange = (key: string, value: string) =>
    {
        if (this.state.language &&  this.props.value &&  this.props.value.valuesUrl)
        {
            this.props.addOrUpdateFieldValue(this.props.field.name, this.state.language.name, this.props.value.valuesUrl, key, value);
        }
    }


    render()
    {
        const { languages, onClose } = this.props;
        const { language } = this.state;
        const languageSelector: IContextualMenuItem[] = languageMenu(languages, this.onLanguageClick);
        let englishName =  "";
        let keyValuePair = {};
        if (language)
        {
            englishName = language.englishName;
            if (this.props.translations)
            {
                keyValuePair = this.props.translations[language.name];

            }
        }
       
        const items: ICommandBarItemProps[] = [
            { 
                key: "targetLanguage",
                name: `Language: ${englishName}`,
                subMenuProps: {
                    items: languageSelector,
                },
            }
          
        ];
        return (
            <Dialog hidden={false} onDismiss={onClose} minWidth={550}>
                <CommandBar 
                    items={items}
                />
                <KeyValueList 
                            keyTitle="Key" 
                            valueTitle={englishName} 
                            list={keyValuePair}
                            onChange={this.onListChange} 
                        />
            </Dialog>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TranslationDialog);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/dropdown/TranslationDialog.tsx